// Xem chi tiết một bảng kê đã lập. Dùng lại nguyên StepViewStatement của
// luồng tạo, chỉ bật cờ embedded để thanh nút nằm trong modal thay vì dính
// đáy màn hình.
import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { STATEMENT_TYPE_LABEL } from "../constants";
import StepViewStatement from "../CreateStatement/StepViewStatement";

const StatementDetailModal = props => {
  const { isOpen, toggle, statementId, code, adjustMode, onSigned } = props;

  // "Điều chỉnh" / "Thay thế" theo đúng bảng kê đang mở; chưa rõ thì ghi chung
  const typeLabel = STATEMENT_TYPE_LABEL[adjustMode]
    ? STATEMENT_TYPE_LABEL[adjustMode].toLowerCase()
    : "thay thế /điều chỉnh";

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      role="dialog"
      autoFocus
      centered
      toggle={toggle}
      style={{ maxWidth: "95%" }}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Chi tiết bảng kê hóa đơn {typeLabel}
          {code && <span className="text-primary ms-2">{code}</span>}
        </ModalHeader>
        <ModalBody>
          {isOpen && (
            <StepViewStatement
              statementId={statementId}
              onBack={toggle}
              onSigned={() => {
                if (onSigned) onSigned();
                toggle();
              }}
              embedded
            />
          )}
        </ModalBody>
      </div>
    </Modal>
  );
};

StatementDetailModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  statementId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  code: PropTypes.string,
  adjustMode: PropTypes.string,
  onSigned: PropTypes.func,
};

StatementDetailModal.defaultProps = {
  isOpen: false,
  statementId: null,
  code: "",
  adjustMode: "",
  onSigned: undefined,
};

export default StatementDetailModal;
